import React from 'react'
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom'
import DefaultedFinesRoutes from 'containers/DefaultedFines/Router/routes.jsx'
import { withTranslation } from 'react-i18next'
import PageNotFound from 'shared/components/PageNotFound.jsx'
import Layout from 'containers/Layout/topbar/index.jsx'
import Footer from 'containers/Layout/footer/footer.jsx'
import { useSelector } from 'react-redux'
import { css } from '@emotion/core'
import styles from './Router.module.scss'
import FadeLoader from 'react-spinners/FadeLoader'

const Router = ({ i18n, t }) => {
  const isLoading = useSelector((state) => state.metaData.metaData.isLoading)
  const override = css`
    left: 50%;
    top: 25%;
    position: fixed;
    z-index: 9999;
  `

  return (
    <React.Fragment>
      <FadeLoader css={override} height={25} width={8} radius={2} margin={50} color={'#0358A4'} loading={isLoading} />
      <div className={isLoading ? styles['loading'] : ''}>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%' }}>
          <Switch>
            <Route path={`/${i18n.language}`} children={<Translation i18n={i18n} t={t} />} />
            <Route path="/fr" children={<Translation i18n={i18n} t={t} />} />
            <Route
              path="*"
              exact={true}
              children={
                <React.Fragment>
                  <Layout />
                  <PageNotFound />
                  <Footer />
                </React.Fragment>
              }
            />
            <Redirect exact from="/" to={`/${i18n.language}`} />
          </Switch>
        </div>
      </div>
    </React.Fragment>
  )
}

const Translation = ({ i18n, t }) => {
  let match = useRouteMatch()

  try {
    if (match.path === '/fr' && i18n.language !== 'fr') {
      i18n.changeLanguage('fr')
      document.getElementById('ApplicationTitle').innerHTML = t('title')
      document.getElementById('AppLanguage').lang = i18n.language
    }
  } catch (e) {
    console.log(e)
  }

  return <DefaultedFinesRoutes />
}

export default withTranslation('common')(Router)
